// src/stores/useGloStore.js
//
// Manages GLO OLS polygon layer visibility state.
// Consumed by TopNav (toggle button) and MapView (layer sync effect).

import { create } from "zustand";

export const useGloStore = create((set) => ({
  olsVisible: false,
  toggleOls: () => set((s) => ({ olsVisible: !s.olsVisible })),
  setOlsVisible: (v) => set({ olsVisible: v }),
}));
